export class RecommendingOfficer {
  id: String;
  // agencyCode: null,
  firstName: String;
  lastName: String;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/recommending.officer.model.ts